import { CheckScribble } from "@/components/Marks";

/** Selectable card. `role` switches between multi (button/aria-pressed) and single (radio). */
export function OptionCard({ label, sub, active, onClick, single = false, testId }) {
  const aria = single ? { role: "radio", "aria-checked": active } : { "aria-pressed": active };
  return (
    <button type="button" className="opt" onClick={onClick} data-testid={testId} {...aria}>
      <CheckScribble className="opt__mark" />
      <span className="opt__label">{label}</span>
      {sub && <span className="opt__sub">{sub}</span>}
    </button>
  );
}

export function Chip({ label, active, onClick, testId }) {
  return (
    <button type="button" className="opt opt--chip" onClick={onClick} aria-pressed={active} data-testid={testId}>
      <span className="opt__label">{label}</span>
      <CheckScribble className="opt__mark" />
    </button>
  );
}

/** Milestones instead of percentages. Every answer moves a named thing forward. */
export const MILESTONES = ["Business understood", "Workflow mapped", "Opportunities identified", "Impact estimated", "Your roadmap"];

export function Milestones({ done, live }) {
  return (
    <ol className="mile" aria-label="Progress">
      {MILESTONES.map((m, i) => (
        <li key={m} className="mile__item" data-state={i < done ? "done" : i === live ? "live" : "todo"}>
          <i aria-hidden="true" />
          <span>{m}{i < done ? " ✓" : ""}</span>
        </li>
      ))}
    </ol>
  );
}
